import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api-client";

export const getSpecialties = async () => {
    const res = await api.get("/Specialties");

    return res.data;
};

export const useSpecialties = () => {
    return useQuery({
        queryKey: ["specialties"],
        queryFn: getSpecialties,
        retry: 3,
        staleTime: Infinity,
    });
};
